import type {ItemType} from '@PosterWhiteboard/items/item/item.types';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import type {ImageBackground} from '@PosterWhiteboard/page/background/image-background.class';
import type {RectangleItem} from '@PosterWhiteboard/items/rectangle-item/rectangle-item';
import type {VideoItem, VideoItemObject} from '@PosterWhiteboard/items/video-item/video-item.class';
import {FillTypes} from '@PosterWhiteboard/classes/fill.types';
import {convertFabricColorToFillObject} from '@Utils/color.util';

export enum BackgroundTypeName {
  COLOR = 'color',
  IMAGE = 'image',
  VIDEO = 'video',
}

export type VideoBackgroundObject = VideoItemObject

export function isColorBackground(bg: ItemType | undefined): bg is RectangleItem {
  return !!bg?.isBackground && bg.gitype === ITEM_TYPE.RECTANGLE;
}

export function isImageBackground(bg: ItemType | undefined): bg is ImageBackground {
  return !!bg?.isBackground && bg.gitype === ITEM_TYPE.IMAGEBACKGROUND;
}

export function isVideoBackground(bg: ItemType | undefined): bg is VideoItem {
  return !!bg?.isBackground && bg.gitype === ITEM_TYPE.VIDEO;
}

/**
 * A transparent (no-fill) colour background. Copy-styles is intentionally not offered for these —
 * there is no appearance to carry over — so it gates the menu items and the shortcut alike.
 */
export function isTransparentColorBackground(bg: ItemType | undefined): boolean {
  return isColorBackground(bg) && convertFabricColorToFillObject(bg.getFillObject()).fillType === FillTypes.NONE;
}
